// removed by extract-text-webpack-plugin
module.exports = {"container":"_1bOdD2mbgSrr0kVMbLahCE","icon":"_1H1kVY5yHrNKyuA3gZ1UyX","link":"Cgj3bXXCnNJJvuw0FOJ_1","active":"Fn9UlSBhtqdhNtfV5OXp2","isOpen":"XUegTihUSo4pq4vy7K-uo","overlay":"GYsCgtpgDmWfAGDgoMecG","visible":"_2BvBJHDd4YkCRH8WhOWgsQ","close":"_3-mUPiL_AWOYX4aWHR49lT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sideNav/styles.css
// module id = 1095
// module chunks = 0